"use client";

import { PromptHistoryDialog } from "@shared/components/PromptHistoryDialog";
import { useEffect, useState } from "react";
import { useBatchImageToPrompt } from "../hooks/use-batch-image-to-prompt";
import { BatchImagePromptConverter } from "./BatchImagePromptConverter";

export function BatchImageToPromptClient() {
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const { promptHistory, setPromptHistory } = useBatchImageToPrompt();

	// Listen for the openPromptHistory event
	useEffect(() => {
		const handleOpenHistory = () => {
			setIsHistoryOpen(true);
		};

		window.addEventListener("openPromptHistory", handleOpenHistory);

		return () => {
			window.removeEventListener("openPromptHistory", handleOpenHistory);
		};
	}, []);

	return (
		<div className="space-y-12">
			<BatchImagePromptConverter />

			<PromptHistoryDialog
				open={isHistoryOpen}
				onOpenChange={setIsHistoryOpen}
			/>
		</div>
	);
}
